import { set } from '@vueuse/core';
import { onMounted, ref, toValue } from 'vue';
import { useStepperStore } from '../../../stores/stepper.store.js';

export function useStoredValue() {
  const value = ref('');

  function setValue(val: string) {
    useStepperStore().getState().extras.setCardMessage(val);
    set(value, val);
  }

  // FIXME: This seems to create an infinite loop when going back and forth a few times
  // onMounted(() => {
  //   useStepperStore().subscribe((state) => {
  //     if (state.extras.card?.message === undefined) {
  //       return;
  //     }

  //     if (state.extras.card.message !== toValue(value.value)) {
  //       setValue(state.extras.card.message);
  //     }
  //   });
  // });

  return { value, setValue };
}
